import { registerLocaleData } from '@angular/common';
import { Injectable, signal } from '@angular/core';
import localeBg from '@angular/common/locales/bg';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeNb from '@angular/common/locales/nb';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localePtPt from '@angular/common/locales/pt-PT';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeSk from '@angular/common/locales/sk';
import localeSl from '@angular/common/locales/sl';
import localeSv from '@angular/common/locales/sv';
import localeTh from '@angular/common/locales/th';
import localeTr from '@angular/common/locales/tr';
import localeUk from '@angular/common/locales/uk';
import localeZhHans from '@angular/common/locales/zh-Hans';
import localeZhHansExtra from '@angular/common/locales/extra/zh-Hans';
import localeZhHant from '@angular/common/locales/zh-Hant';
import localeZhHantExtra from '@angular/common/locales/extra/zh-Hant';

import { DEFAULT_ANGULAR_LOCALE, resolveLocale } from '../../shared/utils/language.utils';

export function registerSupportedLocales(): void {
  registerLocaleData(localeBg);
  registerLocaleData(localeCs);
  registerLocaleData(localeDa);
  registerLocaleData(localeDe);
  registerLocaleData(localeEl);
  registerLocaleData(localeEnGb);
  registerLocaleData(localeEs);
  registerLocaleData(localeFi);
  registerLocaleData(localeFr);
  registerLocaleData(localeHu);
  registerLocaleData(localeIt);
  registerLocaleData(localeJa);
  registerLocaleData(localeKo);
  registerLocaleData(localeNb);
  registerLocaleData(localeNl);
  registerLocaleData(localePl);
  registerLocaleData(localePtPt);
  registerLocaleData(localeRo);
  registerLocaleData(localeRu);
  registerLocaleData(localeSk);
  registerLocaleData(localeSl);
  registerLocaleData(localeSv);
  registerLocaleData(localeTh);
  registerLocaleData(localeTr);
  registerLocaleData(localeUk);
  registerLocaleData(localeZhHans, 'zh-Hans', localeZhHansExtra);
  registerLocaleData(localeZhHant, 'zh-Hant', localeZhHantExtra);
}

@Injectable()
export class LocaleService {
  readonly angularLocale = signal<string>(DEFAULT_ANGULAR_LOCALE);

  setLanguage(isoCountryCode?: string | null): void {
    this.angularLocale.set(resolveLocale(isoCountryCode));
  }
}
